// see https://validatejs.org/#examples and https://validatejs.org/examples.html

const validate = require('validate.js');

const forms = $('form.validate');

forms.each(function() {
	$(this).on("submit", function(e) {
		e.preventDefault();

		handleFormSubmit($(this));
	});
})

export const handleFormSubmit = (form) => {
	let constraints = form.data('constraints');

	GlobalSettings.debug('Validating ' + form.attr('id'));
	GlobalSettings.debug('Constraints:');
	GlobalSettings.debug(constraints);

	let errors = validate(form, constraints);

	showErrors(form, errors || {});
	if (!errors) {
		if (form.hasClass('ajax')) {
			let ajaxMethod = form.attr("action");
			let data = form.serialize();

			jQuery.ajax({
				url: GlobalSettings.settings.ajaxServiceBase + ajaxMethod,
				method: "POST",
				data: data
			})
			.done(function() {
				if (form.data('thank-you')) {
					form.html(form.data('thank-you'));
				}
			});
		} else {
			form.off().submit();
		}
	}
}

// Updates the inputs with the validation errors
export const showErrors = (form, errors) => {
	$(form).find('input, textarea, select').each(function() {
		showErrorsForInput($(this), errors && errors[$(this).attr('name')]);
	});
}

// Shows the errors for a specific input
export const showErrorsForInput = (input, errors) => {
	let fullError = '';
	let formGroup = input.closest('.form__col');
	let messages = formGroup.find('.messages');

	if (errors) {
		formGroup
			.addClass('has-error')
			.removeClass('has-success');

		fullError = '';
		for (let i=0;i<errors.length;i++) {
			fullError += '<p>' + errors[i] + '</p>';
		}
	} else {
		formGroup
			.removeClass('has-error')
			.addClass('has-success');
	}

	messages.html(fullError);
}